/** @jsxImportSource @emotion/react */
import { colors, HeadingH4, TextItalic } from 'components/landing/ui';
import ShowMoreText from 'react-show-more-text';

import quote from '../../../images/quote.svg';

const Review = ({ currentReviewIndex, reviews, ...rest }) => {
  const { title, review } = reviews[currentReviewIndex];

  return (
    <div
      css={{
        flexDirection: 'column',
        width: '100%',
        position: 'relative',
        paddingBottom: 55,
        paddingTop: 55,
        h4: { marginBottom: 20 },
        '@media (min-width:992px)': { paddingBottom: 70, paddingTop: 70 },
      }}
      {...rest}
    >
      <HeadingH4>{title}</HeadingH4>
      <ShowMoreText
        css={{
          display: 'flex',
          flexDirection: 'column',
          a: {
            display: 'flex',
            width: '100%',
            marginTop: 15,
            justifyContent: 'flex-end',
            fontFamily: 'Open Sans',
            fontSize: 16,
            lineHeight: '22px',
            fontWeight: 400,
            color: colors.blue,
            whiteSpace: 'pre-line',
            wordBreak: 'break-word',
            fontStyle: 'normal',
          },
          span: {
            fontFamily: 'Open Sans',
            fontSize: 16,
            lineHeight: '22px',
            fontWeight: 400,
            color: colors.grayLight,
            whiteSpace: 'pre-line',
            wordBreak: 'break-word',
            fontStyle: 'italic',
          },
        }}
        lines={2}
        more="Показать весь отзыв"
        less="Скрыть весь отзыв"
        truncatedEndingComponent="... "
      >
        <TextItalic css={{ color: colors.grayLight }}>{review}</TextItalic>
      </ShowMoreText>

      <img src={quote} css={{ position: 'absolute', top: 0, transform: 'rotate(180deg)' }} />
      <img src={quote} css={{ position: 'absolute', bottom: 0, right: 0 }} />
    </div>
  );
};

export default Review;
